import {
  BillingPeriod,
  PlanType,
} from '@/features/subscriptions/types/subscription-types';
import { supabase } from '@/lib/supabase/config';
import { getDeeplinkPrefix } from '@/shared/utils/deeplink-prefix';
import { handleError } from '@/shared/utils/error-handling';

interface CreateCheckoutSessionInput {
  organizationId: number;
  planType: PlanType;
  billingPeriod: BillingPeriod;
  projectId?: number;
  returnUrl?: string;
}

type CreateCheckoutSessionResponse =
  | {
      checkoutUrl: string;
      sessionId: string;
      type: 'checkout';
    }
  | {
      subscriptionUpdated?: boolean;
      type: 'subscription-updated';
    };

export async function createCheckoutSession(
  input: CreateCheckoutSessionInput,
): Promise<CreateCheckoutSessionResponse> {
  const { returnUrl, ...rest } = input;
  const { data, error } = await supabase.functions.invoke(
    'create-checkout-session',
    {
      body: {
        ...rest,
        deeplink: getDeeplinkPrefix(),
        returnUrl:
          returnUrl ?? window.location.pathname + window.location.search,
      },
    },
  );

  if (error) {
    const appError = await handleError(error);
    throw appError;
  }

  return data;
}
